/*
 * This file is part of huoxin/filter-rule-manager.
 *
 * Copyright (c) 2026 huoxin.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
export default class FilterRuleWarningModal extends Modal {
  className() {
    return 'FilterRuleWarningModal Modal--small';
  }
  title() {
    return app.translator.trans('huoxin-filter-rule-manager.forum.warning_modal_title');
  }
  content() {
    const alerts = this.attrs.alerts || [];
    return m("div", {
      className: "Modal-body"
    }, m("p", null, app.translator.trans('huoxin-filter-rule-manager.forum.warning_modal_text')), m("ul", {
      className: "FilterRuleManager-FilterRuleWarningModal-list"
    }, alerts.map((alert, i) => m("li", {
      key: i
    }, m.trust(alert.message)))), m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--primary",
      onclick: () => this.attrs.onconfirm()
    }, app.translator.trans('huoxin-filter-rule-manager.forum.warning_modal_continue')), m(Button, {
      className: "Button",
      onclick: () => this.attrs.oncancel()
    }, app.translator.trans('huoxin-filter-rule-manager.forum.warning_modal_cancel'))));
  }
}
flarum.reg.add('huoxin-filter-rule-manager', 'forum/components/FilterRuleWarningModal', FilterRuleWarningModal);